import { useState, useEffect } from "react";
import { getTrainModels, getInspModels } from "../services/modelService.ts";

export const useModelList = (modelType) => {
  const [modelList, setModelList] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const loadMore = async (currentPage) => {
    if (isLoading || !hasMore) return;

    try {
      setIsLoading(true);
      // Autocomplete에서 검색할 때 무한 스크롤이 문제가 됨 -> 우선 300개로 제한
      const response = await (modelType === "train"
        ? getTrainModels({ page: currentPage, pageSize: 300 })
        : getInspModels({ page: currentPage, pageSize: 300 }));

      const newModels = response.data.contents;

      if (newModels.length === 0) {
        setHasMore(false);
        return;
      }

      const filteredModels =
        modelType === "train"
          ? newModels.filter((model) => model.name !== "일괄학습")
          : newModels;

      setModelList((prev) => [...prev, ...filteredModels]);
      setPage(currentPage);
    } catch (error) {
      console.error(`Failed to fetch ${modelType} models:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  const resetList = () => {
    setModelList([]);
    setPage(1);
    setHasMore(true);
    loadMore(1);
  };

  useEffect(() => {
    resetList();
  }, [modelType]);

  return {
    modelList,
    isLoading,
    hasMore,
    loadMore,
    resetList,
    page,
  };
};
